import React from 'react';
const RowValidacionRequisitos = ({
  requisito = {},
  requisitoValidado = { id: null, valid: null },
}) => {
  const [reqvalidado] = React.useState({
    idRequisitoPuesto: requisito.idRequisitoPuesto,
    validado: requisito.presentoDocumentacion,
  });
  const [requisitoChequeado, setRequisitoChequeado] = React.useState(false);
  const handleValidarRequisito = (id, validado) => {
    reqvalidado.validado = !reqvalidado.validado;
    requisitoValidado?.(id, validado);
  };
  return (
    <>
      <tr key={requisito.idRequisitoPuesto} className="align-items-center">
        <td className="text-center">
          <input
            type="checkbox"
            onClick={() => {
              handleValidarRequisito(reqvalidado.idRequisitoPuesto, !reqvalidado.validado);
              setRequisitoChequeado(!requisitoChequeado);
            }}
            checked={reqvalidado.validado}
          />
        </td>
        <td className="align-middle">{requisito.nombreRequisito}</td>
        <td className="align-middle">{requisito.descripcionRequisito}</td>
        <td className="align-middle text-center">
          {requisito.requerido || requisito.excluyente ? 'X' : ''}
        </td>
        {/* <td className="text-center align-middle">{requisito.escluyente ? 'X' : ''}</td> */}
      </tr>
    </>
  );
};
export default RowValidacionRequisitos;
